export const getArtikelKonfiguration = async (kArtikel: number): Promise<ArtikelKonfiguration> => {
  let host = '';
  if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost:3002';
  }
  const ioConfig = { name: 'stm_configurator', params: { type: 'config', kArtikel } };
  return fetch(`${host}/io?io=${encodeURIComponent(JSON.stringify(ioConfig))}`, { method: 'GET' })
    .then((resp: any) => resp.json());
};

const artikelInfoCache = new Map<number, Artikel>();
export const getArtikelInfo = async (kArtikel: number): Promise<Artikel> => {
  if (artikelInfoCache.has(kArtikel)) {
    return Promise.resolve(artikelInfoCache.get(kArtikel) as Artikel);
  }
  let host = '';
  if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost:3002';
  }
  const ioInfo = { name: 'stm_configurator', params: { type: 'info', kArtikel } };
  return fetch(`${host}/io?io=${encodeURIComponent(JSON.stringify(ioInfo))}`, { method: 'GET' })
    .then((resp: any) => resp.json())
    .then((artikel: Artikel) => {
      artikelInfoCache.set(kArtikel, artikel);
      return artikel;
    });
};

const artikelInfoByArtNrCache = new Map<string, Artikel>();
export const getArtikelInfoByArtNr = async (artNr: string): Promise<Artikel> => {
  if (artikelInfoByArtNrCache.has(artNr)) {
    return Promise.resolve(artikelInfoByArtNrCache.get(artNr) as Artikel);
  }
  let host = '';
  if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost:3002';
  }
  const ioInfo = { name: 'stm_configurator', params: { type: 'info-by-artnr', artNr } };
  return fetch(`${host}/io?io=${encodeURIComponent(JSON.stringify(ioInfo))}`, { method: 'GET' })
    .then((resp: any) => resp.json())
    .then((artikel: Artikel) => {
      artikelInfoByArtNrCache.set(artNr, artikel);
      return artikel;
    });
};

export const getKategorieInfo = async (kKategorie: number): Promise<Kategorie> => {
  let host = '';
  if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost:3002';
  }
  const ioCategory = { name: 'stm_configurator', params: { type: 'category', kKategorie } };
  return fetch(`${host}/io?io=${encodeURIComponent(JSON.stringify(ioCategory))}`, { method: 'GET' })
    .then((resp: any) => resp.json());
};

export const getShopInfo = async (): Promise<ShopKonfiguration> => {
  let host = '';
  if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost:3002';
  }
  const ioShop = { name: 'stm_configurator', params: { type: 'shop' } };
  return fetch(`${host}/io?io=${encodeURIComponent(JSON.stringify(ioShop))}`, { method: 'GET' })
    .then((resp: any) => resp.json());
};

export const getPriceTable = async (kArtikel: number): Promise<PriceTableKonfiguration> => {
  let host = '';
  if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost:3002';
  }
  const ioPrice = { name: 'stm_configurator', params: { type: 'price', kArtikel } };
  return fetch(`${host}/io?io=${encodeURIComponent(JSON.stringify(ioPrice))}`, { method: 'GET' })
    .then((resp: any) => resp.json());
};

export const getKEigenschaftWertToValueMapping = async (kArtikel: number): Promise<string> => {
  let host = '';
  if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost:3002';
  }
  const ioValueMapping = { name: 'stm_configurator', params: { type: 'kEigenschaftWertToValue', kArtikel } };
  return fetch(`${host}/io?io=${encodeURIComponent(JSON.stringify(ioValueMapping))}`, { method: 'GET' })
    .then((resp: any) => resp.text());
};
